import { DateTimeUtils, useTimezone, useAppNowUtc } from '@mews/framework';

/**
 * Custom hook that returns today's date in ISO format (YYYY-MM-DD) based on the current UTC time
 * converted to the application's timezone.
 *
 * @returns Today's date in ISO format (YYYY-MM-DD) in the application's timezone
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const todayISO = useGetTodayISO();
 *   console.log(todayISO); // "2023-12-15"
 *
 *   return <div>Today: {todayISO}</div>;
 * };
 * ```
 */
export const useGetTodayISO = () => {
    const appNowUtc = useAppNowUtc();
    const timezone = useTimezone();
    const appNowISO = DateTimeUtils.dateTimeUtcStringToDateISOString(appNowUtc.value, timezone);

    return appNowISO;
};
